module.exports = __webpack_public_path__ + "static/media/root-badge.40e90cf1.svg";